import React from 'react';

const bottomDivStyle = {
    bottom: 0,
    fontSize: "12px",
    background: "white",
    position: "absolute",
    width: "100%",
    backgroundColor:"rgba(60, 60, 60, 0.59)",
    color: "white",
    display: "inlineBlock"
  }
export default function BottomSection() {
    return(
        <div style={bottomDivStyle}>
          <div>
          
          <p>
          Keyboard Shortcut: (P = Pause/Play) &#9900; (R = Reset) &#9900; (N = New background image) &#9900; (Q = Rain Sound)
          {/* <a target="_blank" href="https://paypal.me/ShezanSharif?locale.x=en_GB">
          <img src="https://img.icons8.com/material-rounded/24/000000/like.png"/>
          </a> */}
          </p>

          </div>
        </div>
      )  
} 